import React from 'react';

export enum AgentCategory {
  INVESTIGATING_TEXTS = 'Investigando Textos',
  MAPPING_THEMES = 'Mapeando Temas',
  EXPLORING_MEANINGS = 'Explorando Significados',
  PREPARING_MESSAGES = 'Preparando Mensagens',
}

export enum AgentType {
  WELCOME = 'Boas-Vindas',
  DEVOCIONAL_PESSOAL = 'Devocional Pessoal',
  WORD_ANALYZER = 'Analisador de Palavras', 
  TRANSLATION_COMPARATOR = 'Comparador de Traduções',
  BIBLE_STUDY_CREATOR = 'Criador de Estudos Bíblicos',
  LITERARY_FORM = 'Forma Literária',
  BIBLICAL_UNIT_IDENTIFIER = 'Identificador de Unidades',
  CHARACTERS = 'Caracterizar Personagens',
  CONTEXT_RESEARCHER = 'Pesquisador de Contexto',
  SERMON_BUILDER = 'Construtor de Sermões',
  ILLUSTRATION_GENERATOR = 'Gerador de Ilustrações',
  TARGET_AUDIENCE_DEFINER = 'Definidor de Público-alvo',
  LESSON_PREPARER = 'Preparador de Aulas',
  POST_CREATOR = 'Sugerir Posts',
  TEXT_UPDATER = 'Atualizar Texto',
  WORLDVIEW_ANALYZER = 'Examinar Cosmovisão',
  INTERPRETATION_HISTORIAN = 'Historiar Interpretação',
  DESCRIBE_THEOLOGIES = 'Descrever Teologias',
  EXPLORE_THEMES = 'Explorar Temas',
  BIOGRAPH_CHARACTERS = 'Biografar Personagens',
  RELATE_TEXTS = 'Relacionar Textos',
  GENERATE_BOOK_THEOLOGY = 'Apresentar Teologia Livros',
}

export interface AgentInfo {
  id: AgentType;
  name: string;
  description: string;
  icon: React.ReactNode;
  category?: AgentCategory;
  url?: string;
}

export interface Step {
  id: string;
  title: string;
  status: 'pending' | 'running' | 'success' | 'error';
  content?: unknown;
  type?: 'json' | 'markdown' | null;
  error?: string | null;
}

export interface WordDetail { 
  label: string; 
  value: string; 
  isLink?: boolean; 
  isMarkdown?: boolean; 
}

export interface ParsedWord { 
  termName: string; 
  details: WordDetail[]; 
}

export type SectionElement = 
  | { type: 'H1_MARKDOWN'; titleLine: string; contentLines: string[] } 
  | { type: 'WORD_TABLE'; wordData: ParsedWord };

export interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

// User Profile Types
export interface UserProfile {
  id: string;
  company?: string;
  position?: string;
  industry?: string;
  address?: string;
  phone?: string;
  city?: string;
  state?: string;
  country?: string;
  postal_code?: string;
  timezone?: string;
  notification_preferences?: Record<string, any>;
  general_settings?: Record<string, any>;
  created_at?: string;
  updated_at?: string;
}

export interface UserWithProfile {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  is_active: boolean;
  email_verified: boolean;
  created_at: string;
  is_superuser: boolean;
  is_staff: boolean;
  profile?: UserProfile;
}

export interface ProfileUpdateData {
  // User fields
  first_name?: string;
  last_name?: string;
  email?: string;
  // Profile fields
  company?: string;
  position?: string;
  industry?: string;
  address?: string;
  phone?: string;
  city?: string;
  state?: string;
  country?: string;
  postal_code?: string;
  timezone?: string;
  notification_preferences?: Record<string, unknown>;
  general_settings?: Record<string, unknown>;
}

/** Payload para criação de análise (POST /analyses). */
export interface AnalysisCreatePayload {
  agent_id?: string | number;
  title?: string;
  content?: string;
  metadata?: Record<string, unknown>;
  [key: string]: unknown;
}

/** Formato de agente retornado pela API (lista de agentes). */
export interface AgentFromApi {
  id: number;
  code: string;
  name: string;
  short_description?: string;
  description?: string;
  status: string;
  package_code: string;
  icon?: string;
}

/** Configuração genérica para chamadas LLM (NVI/gemini). */
export interface LLMCallConfig {
  temperature?: number;
  topP?: number;
  topK?: number;
  responseMimeType?: string;
  [key: string]: unknown;
}
